import { ToolItem } from "./tool-item";
import { loadJsonFromUrl } from "../util/json-loader";

const TOOLS_JSON_URL = "/data/tools.json";

async function loadTools(): Promise<ToolItem[] | null> {
  const tools = await loadJsonFromUrl<ToolItem[]>(TOOLS_JSON_URL);
  if (tools === null) {
    console.error(
      `Failed to load tools from ${TOOLS_JSON_URL}. Returning empty list.`,
    );
    return null;
  }

  return tools;
}

function buildToolRow(tool: ToolItem): string {
  const toolName = tool.link
    ? `<a href="${tool.link}">${tool.name}</a>`
    : tool.name;
  const description = tool.description
    ? `<p class="tool-description">${tool.description}</p>`
    : "";
  const demoLink = tool.demo
    ? `<a href="${tool.demo}"><img src="/assets/youtube.png" height="24px" style="vertical-align: middle"></a>`
    : "";
  return `<tr>
        <td>${toolName}${description}</td>
        <td>${demoLink}</td>
    </tr>`;
}

async function buildToolTable(tools: ToolItem[]): Promise<string> {
  const rows = tools.map(buildToolRow).join("\n");
  return `<table title="Tools available to borrow from Richmond Woodturners" summary="Tools available to borrow from Richmond Woodturners">
        <thead>
            <tr>
                <th>Tool</th>
                <th>Demo</th>
            </tr>
        </thead>
        <tbody>
            ${rows}
        </tbody>
    </table>`;
}

export function fillToolsList(sectionId: string): void {
  loadTools().then((tools) => {
    if (tools === null) {
      fillErrorToolsList(sectionId);
      return;
    }

    const section = document.getElementById(sectionId);
    if (!section) return;

    buildToolTable(tools).then((html) => {
      section.innerHTML = html;
      if (section.classList.contains("expand-in")) {
        section.classList.add("visible");
      }
    });
  });
}

function fillErrorToolsList(sectionId: string): void {
  const section = document.getElementById(sectionId);
  if (!section) return;

  section.innerHTML =
    "<p>Failed to load tools list. Please try again later.</p>";
}
